
	//Vec3D is defined in toxi/geom/vectors to circumvent circular dependencies
	module.exports = require('./vectors').Vec3D;



//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/geom/Vec3D.js
// module id = 6
// module chunks = 14